// Section id → component. The one place a section's home is decided.
//
// Kept apart from `sections.js` so the *model* (labels, gating, URLs) can be
// read and tested without pulling eight component trees in behind it — the
// tests that check the index against `areas.js` need the model and nothing
// else.
//
// Moving a block between sections is an edit inside one of these components;
// moving a whole section is an edit here. Both are one file.
import Capabilities from "./Capabilities";
import Connections from "./Connections";
import Infrastructure from "./Infrastructure";
import Models from "./Models";
import MyEA from "./MyEA";
import MySettings from "./MySettings";
import Offers from "./Offers";
import People from "./People";
import SystemConfiguration from "./SystemConfiguration";

const SECTION_COMPONENTS = {
  me: MySettings,
  ea: MyEA,
  offers: Offers,
  connections: Connections,
  models: Models,
  capabilities: Capabilities,
  infrastructure: Infrastructure,
  system: SystemConfiguration,
  people: People,
};

export default SECTION_COMPONENTS;
